import createArrayFacet from '../../createArrayFacet';

export default createArrayFacet({
  stateKey: 'grapeVarieties',
  itemKey: 'grapeVarieties',
  itemSubKey: 'varietyName',
});
